import i18n from "./i18n";

export class HeaderTexts {
  private constructor() {}
}

export class GeneralTexts {
  constructor() {}
  static get login() {
    return i18n.t(`login.${i18n.language}`);
  }
  static get example() {
    return i18n.t(`example.${i18n.language}`);
  }
  static get productInformation() {
    return i18n.t(`productInformation.${i18n.language}`);
  }
  static get livePreview() {
    return i18n.t(`livePreview.${i18n.language}`);
  }
}

export class WebViewTexts {
  constructor() {}
  static get attributes() {
    return i18n.t(`attributes.${i18n.language}`);
  }
  static get documents() {
    return i18n.t(`documents.${i18n.language}`);
  }
  static get footerTitle() {
    return i18n.t(`footerTitle.${i18n.language}`);
  }
  static get general() {
    return i18n.t(`general.${i18n.language}`);
  }
  static get serialNumber() {
    return i18n.t(`serialNumber.${i18n.language}`);
  }
  static get materialNumber() {
    return i18n.t(`materialNumber.${i18n.language}`);
  }
  static get manufacturerDate() {
    return i18n.t(`manufacturerDate.${i18n.language}`);
  }
  static get manufacturerName() {
    return i18n.t(`manufacturerName.${i18n.language}`);
  }
  static get manufacturerWebseite() {
    return i18n.t(`manufacturerWebseite.${i18n.language}`);
  }
  static get dppPromoSubtitle() {
    return i18n.t(`dppPromoSubtitle.${i18n.language}`);
  }
  static get dppPromoTitle() {
    return i18n.t(`dppPromoTitle.${i18n.language}`);
  }
  static get dppPromoMainText() {
    return i18n.t(`dppPromoMainText.${i18n.language}`);
  }
  static get dppPromoSubText1() {
    return i18n.t(`dppPromoSubText1.${i18n.language}`);
  }
  static get dppPromoSubText2() {
    return i18n.t(`dppPromoSubText2.${i18n.language}`);
  }
  static get dppPromoCta() {
    return i18n.t(`dppPromoCta.${i18n.language}`);
  }
  static get dppUrl() {
    return i18n.t(`dppUrl.${i18n.language}`);
  }
}

export class FormTexts {
  constructor() {}
  static get attributes() {
    return i18n.t(`attributes.${i18n.language}`);
  }
  static get productName() {
    return i18n.t(`productName.${i18n.language}`);
  }
  static get productNameBatteryPass() {
    return i18n.t(`productNameBatteryPass.${i18n.language}`);
  }
  static get serialNumberForm() {
    return i18n.t(`serialNumberForm.${i18n.language}`);
  }
  static get formTitle() {
    return i18n.t(`formTitle.${i18n.language}`);
  }
  static get formTitleBatteryPass() {
    return i18n.t(`formTitleBatteryPass.${i18n.language}`);
  }
  static get formSubTitle() {
    return i18n.t(`formSubTitle.${i18n.language}`);
  }
  static get formSubTitleGemueInternal() {
    return i18n.t(`formSubTitleGemueInternal.${i18n.language}`);
  }
  static get formSubTitleBatteryPass() {
    return i18n.t(`formSubTitleBatteryPass.${i18n.language}`);
  }
  static get manufacturerIcon() {
    return i18n.t(`manufacturerIcon.${i18n.language}`);
  }
  static get productIcon() {
    return i18n.t(`productIcon.${i18n.language}`);
  }
  static get manufacturerColor() {
    return i18n.t(`manufacturerColor.${i18n.language}`);
  }
  static get keyValues() {
    return i18n.t(`keyValues.${i18n.language}`);
  }
  static get email() {
    return i18n.t(`email.${i18n.language}`);
  }
  static get dragDropText() {
    return i18n.t(`dragDropText.${i18n.language}`);
  }
  static get freeTest() {
    return i18n.t(`freeTest.${i18n.language}`);
  }
  static get privacyText() {
    return i18n.t(`privacyText.${i18n.language}`);
  }
  static get privacyLink() {
    return i18n.t(`privacyLink.${i18n.language}`);
  }
  static get dataProtectionUrl() {
    return i18n.t(`dataProtectionUrl.${i18n.language}`);
  }
  static get dataProtectionText1() {
    return i18n.t(`dataProtectionText1.${i18n.language}`);
  }
  static get dataProtectionText2() {
    return i18n.t(`dataProtectionText2.${i18n.language}`);
  }
  static get voluntaryText_1() {
    return i18n.t(`voluntaryText_1.${i18n.language}`);
  }
  static get voluntaryText_2() {
    return i18n.t(`voluntaryText_2.${i18n.language}`);
  }
  static get chooseSingleFile() {
    return i18n.t(`chooseSingleFile.${i18n.language}`);
  }
  static get chooseMultipleFile() {
    return i18n.t(`chooseMultipleFile.${i18n.language}`);
  }
  static get nothingChosen() {
    return i18n.t(`nothingChosen.${i18n.language}`);
  }
  static get invalidFileType() {
    return i18n.t(`invalidFileType.${i18n.language}`);
  }
  static get exampleQR() {
    return i18n.t(`exampleQR.${i18n.language}`);
  }
  static get addProductInfo() {
    return i18n.t(`addProductInfo.${i18n.language}`);
  }
  static get addManufacturerInfo() {
    return i18n.t(`addManufacturerInfo.${i18n.language}`);
  }
  static get addProductionInfo() {
    return i18n.t(`addProductionInfo.${i18n.language}`);
  }
  static get addAttributes() {
    return i18n.t(`addAttributes.${i18n.language}`);
  }
  static get addIcons() {
    return i18n.t(`addIcons.${i18n.language}`);
  }
  static get addBranding() {
    return i18n.t(`addBranding.${i18n.language}`);
  }
  static get addDocuments() {
    return i18n.t(`addDocuments.${i18n.language}`);
  }
}

export class AlertTexts {
  constructor() {}
  static get fillKeyValue() {
    return i18n.t(`fillKeyValue.${i18n.language}`);
  }
  static get successMessage() {
    return i18n.t(`successMessage.${i18n.language}`);
  }
  static get unexpectedError() {
    return i18n.t(`unexpectedError.${i18n.language}`);
  }
  static get createAgain() {
    return i18n.t(`createAgain.${i18n.language}`);
  }
  static get modalText() {
    return i18n.t(`modalText.${i18n.language}`);
  }
  static get modalTextGemue() {
    return i18n.t(`modalTextGemue.${i18n.language}`);
  }
  static get modalSubTextGemue() {
    return i18n.t(`modalSubTextGemue.${i18n.language}`);
  }
  static get modalTextBatteryPass() {
    return i18n.t(`modalTextBatteryPass.${i18n.language}`);
  }
  static get componentExists() {
    return i18n.t(`componentExists.${i18n.language}`);
  }
  static get outOfEmailLimit() {
    return i18n.t(`outOfEmailLimit.${i18n.language}`);
  }
  static get enterValidUrl() {
    return i18n.t(`enterValidUrl.${i18n.language}`);
  }
}
